module.exports = __webpack_public_path__ + "static/media/Icon-map-orange.956b32ae.svg";